import { useEffect, useState } from "react";
import api from "@/api/client";
import { ProductCard } from "@/components/ProductCard";
import { FilterBar } from "@/components/FilterBar";

export function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("All");
  const [fitment, setFitment] = useState("All");
  const [maxPrice, setMaxPrice] = useState(2000);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const params = new URLSearchParams();
    if (category !== "All") params.set("category", category);
    if (fitment !== "All") params.set("fitment", fitment);
    if (maxPrice < 2000) params.set("max_price", maxPrice);
    if (search) params.set("search", search);
    setLoading(true);
    api.get(`/products?${params.toString()}`)
      .then(({ data }) => setProducts(data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [category, fitment, maxPrice, search]);

  return (
    <div className="pt-[73px]">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
        <div className="mb-8">
          <p className="font-mono text-sm uppercase tracking-widest text-volt">Catalog</p>
          <h1 className="mt-2 font-display text-5xl font-bold uppercase tracking-tight text-white sm:text-6xl" data-testid="shop-heading">
            All Parts
          </h1>
        </div>

        <FilterBar
          category={category}
          setCategory={setCategory}
          fitment={fitment}
          setFitment={setFitment}
          maxPrice={maxPrice}
          setMaxPrice={setMaxPrice}
          search={search}
          setSearch={setSearch}
        />

        <div className="mt-4 flex items-center justify-between">
          <p className="font-mono text-sm uppercase tracking-widest text-slate-500" data-testid="product-count">
            {products.length} {products.length === 1 ? "part" : "parts"}
          </p>
        </div>

        {loading ? (
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="aspect-square animate-pulse border border-white/10 bg-surface" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="mt-12 border border-white/10 bg-surface p-16 text-center" data-testid="no-products">
            <p className="font-mono text-sm uppercase tracking-widest text-slate-500">No parts match your filters</p>
            <button
              onClick={() => { setCategory("All"); setFitment("All"); setMaxPrice(2000); setSearch(""); }}
              className="mt-6 font-mono text-sm uppercase tracking-widest text-volt hover:text-white"
              data-testid="reset-filters"
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="products-grid">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
